import { render, staticRenderFns } from "./LayoutWorld.vue?vue&type=template&id=0da0bdd6&scoped=true&"
import script from "./LayoutWorld.vue?vue&type=script&lang=js&"
export * from "./LayoutWorld.vue?vue&type=script&lang=js&"
import style0 from "./LayoutWorld.vue?vue&type=style&index=0&id=0da0bdd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da0bdd6",
  null
  
)

export default component.exports